module.exports = __webpack_public_path__ + "img/rhino_logo_white.6dc7fbe5.png";